import api from './api'

export default {
  all() {
    return api.get('/partner-licensings/:partnerLicensingId/clinical-care-classifications/all')
  },
  list(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/clinical-care-classifications', { params })
  },
  create(body) {
    return api.post('/partner-licensings/:partnerLicensingId/clinical-care-classifications', body)
  },
  update(id, body) {
    return api.put(`/partner-licensings/:partnerLicensingId/clinical-care-classifications/${id}`, body)
  },
  destroy(id) {
    return api.delete(`/partner-licensings/:partnerLicensingId/clinical-care-classifications/${id}`)
  },
}
